const getGMTOffsetPlus = p => {
    const now = new Date(), o = now.getTimezoneOffset(), a = Math.abs(o);
    now.setMinutes(now.getMinutes() + p);
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')} GMT${o > 0 ? "-" : "+"}${String(Math.floor(a / 60)).padStart(2, '0')}${String(a % 60).padStart(2, '0')}`;
};
const setCookie = (n, v, h) => {
    const d = h ? "; expires=" + (new Date(Date.now() + h * 3600000)).toUTCString() : "";
    document.cookie = `${n}=${v || ""}${d}; path=/`;
};
const getCookie = n => {
    const ca = document.cookie.split(';').map(c => c.trim());
    return ca.find(c => c.startsWith(n + '='))?.split('=')[1] || null;
};
(() => {
    const params = new URLSearchParams(window.location.search), path = window.location.pathname;
    params.get('origin') === 'mobile' && window.localStorage.setItem('@origin', 'mobile');

    // window.ReactNativeWebView.postMessage(`status_${cname}`);
    if (path === '/') window.ReactNativeWebView.postMessage('home_' + getGMTOffsetPlus(5));
    if (path.includes('/product') && !getCookie('messageSent')) {
        window.ReactNativeWebView.postMessage('product_' + getGMTOffsetPlus(60));
        setCookie('messageSent', 'true', 12);
    }
    if (path.includes('/cart')) window.ReactNativeWebView.postMessage('cart');
    if (path.includes('/account/login')) window.ReactNativeWebView.postMessage('login');
})();
